import keyframes from './SearchBox.keyframes.css';

const clearIconAnimationDurationSeconds = 1/3;

let styles = {
  container: {
    position: 'relative',
  },
  clearIcon: {
    position: 'absolute',
    top: '8px',
    right: '12px',
    cursor: 'pointer',
    animation: `${keyframes.fadeIn} ${clearIconAnimationDurationSeconds}s`,
  },
  searchIcon: {
    position: 'absolute',
    top: '8px',
    left: '12px',
    pointerEvents: 'none',
  },
  input: {
    width: '100%',
    paddingLeft: '40px',
    paddingRight: '38px',
  },
};

export default styles;
